import BFFAPI from './utils/BFFAPI';

class FeaturesAPI extends BFFAPI {
  getFeatureActive = (featureName: string) => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/${featureName}`
    );
    return this.fetch<boolean>(req);
  };
}

export default new FeaturesAPI('/fleet/public/features');
